import { Routes, Route } from 'react-router-dom';
import { MainPage } from './assets/trip/mainPage/trip';
import { TripTools } from './assets/trip/mainPage/TripTools';
import { ExpensesPage } from './assets/trip/expenses/expenses';
import { Login } from './assets/trip/login/login';
import { Signup } from './assets/trip/login/signup';
import { AllTrips } from './assets/trip/all-trips/dashboard';
import { NewTrip } from './assets/trip/newTrip/new-trip';
import { EachTripHistory } from './assets/trip/all-trips/dashboard_for_each_trip_from_history/tripHistory';
import { useState, useEffect } from 'react';
import { HeaderPage } from './assets/trip/header/headerpage';
import { TripContext } from './assets/trip/context';
import { getUserInfo } from './assets/trip/utils/fatch';
//import { Suggestions } from './assets/trip/suggestions/Suggestions';
import { About } from './assets/trip/about/about';
import { Website } from './assets/website/website';
import { AdminDashboard } from './assets/admin/adminPage';
import { UserManagement } from './assets/admin/users/users';
import { UserDetailPage } from './assets/admin/users/userDetail';
import { ExpenseManagement } from './assets/admin/expenses/expenses';
import { TripsManagement } from './assets/admin/trips/trips';
import { MessagesManagement } from './assets/admin/messages/messages';
import { Navigate } from 'react-router-dom';
import { NotFoundPage } from './assets/website/NotFound';
import { WeatherPage } from './assets/trip/weather/weatherPage';
import { TripSettingsPage } from './assets/trip/all-trips/tripSettings';
import { DateTime } from "luxon";
import { SuggestedActivities } from './assets/trip/suggestions/SuggestedActivities';
import { FlightsPage } from './assets/trip/suggestions/flights/flights';
import { DetailsForEachActivity } from './assets/trip/suggestions/activities/eachActivity';
import { TagAdminPage } from './assets/admin/tags/tags';
import { EmailMarketing } from './assets/admin/emailMarketing/EmailMarketing';
import { Analytics } from './assets/admin/analytics/Analytics';
import { DayReport } from './assets/admin/analytics/DayReport';

import { AttractionProductsPage } from './assets/trip/suggestions/AttractionProductsPage';
//import { SuggestedActivities3 } from './assets/trip/suggestions/SuggestedActivities3';
//import { SuggestedTours } from './assets/trip/suggestions/tours';

import { ForgotPassword } from './assets/trip/login/forgotPassword';
import { ResetPassword } from './assets/trip/login/resetPassword';
import { ShareTripPage } from './assets/trip/sharing/shareTrip';
import { AcceptInvitePage } from './assets/trip/sharing/acceptInvite';
import { Login1 } from './assets/newLogin/login1';
import { Login2 } from './assets/newLogin/login2';
import { Login3 } from './assets/newLogin/login3';
import { Login4 } from './assets/newLogin/login4';




function App() {

    const [loadingUserInfo, setLoadingUserInfo] = useState(true);
    const [adminControl, setAdminControl] = useState(false);

    const [currentTripId, setCurrentTripId] = useState(null);
    const [weatherActive, setWeatherActive] = useState({ active: false, endAlready: true });
    const [firstName, setFirstName] = useState(null);
    const [trip_name, setTrip_name] = useState('');
    const [loggedIn, setLoggedIn] = useState(false);
    const [redirectFromSignup, setRedirectFromSignup] = useState(false);
    const [currentTripStartDate, setCurrentTripStartDate] = useState('');
    const [currentTripEndDate, setCurrentTripEndDate] = useState('');

    useEffect(() => {

        function getTripStatus() {

            const tripStartDate = DateTime.fromISO(currentTripStartDate).setZone("UTC");

            const tripEndDate = DateTime.fromISO(currentTripEndDate).setZone("UTC");
            const today = DateTime.now().setZone("UTC");






            const daysUntilStart = tripStartDate.diff(today, "days").days - 5;
            const daysUntilEnd = tripEndDate.diff(today, "days").days;


            const active = daysUntilStart <= 0 && daysUntilEnd >= 0;
            const ended = daysUntilEnd < 0;


            setWeatherActive({ active: active, endAlready: ended });




        }

        if (currentTripStartDate && currentTripEndDate) {
            getTripStatus();
        }




    }, [currentTripStartDate, currentTripEndDate])

    useEffect(() => {
        let timer;
        if (redirectFromSignup) {
            timer = setTimeout(() => {
                setRedirectFromSignup(false);
            }, 1000);
        }
        return () => clearTimeout(timer);
    }, [redirectFromSignup]);


    useEffect(() => {
        const getData = async () => {
            try {
                const response = await getUserInfo();

                if (response.loggedIn) {
                    if (response.trips) {
                        setCurrentTripId(response.data.currentTripInfo.current_trip_id);
                        setTrip_name(response.data.currentTripInfo.trip_name);


                        const { start_date, end_date } = response.data.currentTripInfo;
                        setCurrentTripStartDate(start_date);
                        setCurrentTripEndDate(end_date);
















                    } else {
                        setCurrentTripId(null);
                    }


                    setFirstName(response.data.firstName);
                    setAdminControl(response.data.admin);
                    setLoggedIn(true);


                } else {
                    setLoggedIn(false)

                }

            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoadingUserInfo(false);
            }
        };

        getData();



    }, [loggedIn, currentTripId])

    return (
        <>

            <TripContext.Provider value={{
                currentTripId, setCurrentTripId, firstName, setFirstName, trip_name, setTrip_name, setLoggedIn, loggedIn,
                loadingUserInfo, adminControl, setAdminControl, setRedirectFromSignup, weatherActive, setCurrentTripStartDate, setCurrentTripEndDate
            }}>
                <Routes>
                    {!loadingUserInfo && <>
                        {/*   <Route path="/" element={<Navigate to="/login" replace />} /> */}
                        <Route path="/" element={<Website />} />
                        <Route path="invite/:token" element={<AcceptInvitePage />} />
                        <Route path="forgot-password" element={<ForgotPassword />} />
                        <Route path="reset-password/:token" element={<ResetPassword />} />
                        {!redirectFromSignup && <>
                         <Route element={<HeaderPage />} >
                            <Route path="login" element={loggedIn ? <Navigate to="/add_expense" replace /> : <Login />} />
                            <Route path="signup" element={loggedIn ? <Navigate to="/add_expense" replace /> : <Signup />} />
                            </Route>
                        </>}


                        <Route element={<HeaderPage />} >
                            {loggedIn ? <>



                                <Route path="add_expense" element={<MainPage />} />
                                <Route path="trip-tools" element={<TripTools />} />
                                <Route path="my_expenses" element={<ExpensesPage />} />
                                <Route path="all_trips" element={<AllTrips />} />
                                <Route path="trip/:id" element={<EachTripHistory />} />
                                <Route path="share_trip/:id" element={<ShareTripPage />} />
                           {/*      <Route path="suggestions2" element={<Suggestions />} /> */}

                                <Route path="suggestions" element={<SuggestedActivities />} />
                                <Route path="suggestions/flights" element={<FlightsPage />} />
                          {/*       <Route path="suggestions3" element={<SuggestedActivities3 />} /> */}
                                 {/*   <Route path="tours" element={<SuggestedTours />} /> */}
                                


                                <Route path="weather" element={<WeatherPage />} />
                                <Route path="update_trip/:id" element={<TripSettingsPage />} />
                                <Route path="activity_details/:place_id" element={<DetailsForEachActivity />} />
                                <Route path="attraction/:attractionId/products" element={<AttractionProductsPage />} />

                            </> : <>
                                <Route path="add_expense" element={<Navigate to="/login" replace />} />
                                <Route path="trip-tools" element={<Navigate to="/login" replace />} />
                                <Route path="my_expenses" element={<Navigate to="/login" replace />} />
                                <Route path="all_trips" element={<Navigate to="/login" replace />} />
                                <Route path="trip/:id" element={<Navigate to="/login" replace />} />
                                <Route path="share_trip/:id" element={<Navigate to="/login" replace />} />
                                <Route path="suggestions" element={<Navigate to="/login" replace />} />
                                <Route path="suggestions/flights" element={<Navigate to="/login" replace />} />
                                <Route path="weather" element={<Navigate to="/login" replace />} />
                                <Route path="login1" element={<Login1 />} />
                                <Route path="login2" element={<Login2 />} />
                                <Route path="login3" element={<Login3 />} />
                                <Route path="login4" element={<Login4 />} />

                            </>

                            }
                            <Route path="about" element={<About />} />

                        </Route>

                        {loggedIn ?
                            <Route path="new_trip" element={<NewTrip />} />
                            :
                            <Route path="new_trip" element={<Navigate to="/login" replace />} />
                        }



                        {adminControl &&
                            <Route path="admin"  >
                                <Route index element={<AdminDashboard />} />
                                <Route path="users" element={<UserManagement />} />
                                <Route path="users/:userId" element={<UserDetailPage />} />
                                <Route path="expenses" element={<ExpenseManagement />} />
                                <Route path="trips" element={<TripsManagement />} />
                                <Route path="messages" element={<MessagesManagement />} />
                                <Route path="tags" element={<TagAdminPage />} />
                                <Route path="email" element={<EmailMarketing />} />
                                <Route path="analytics" element={<Analytics />} />
                                <Route path="analytics/day/:date" element={<DayReport />} />


                            </Route>


                        }

                        <Route element={<HeaderPage />} >
                            <Route path="*" element={<NotFoundPage />} />

                        </Route>
                    </>}


                </Routes>
            </TripContext.Provider>
        </>
    );
}


export default App
